export default {
  0: '服务错误',
  10001: '参数不合法',
  10002: '用户状态异常',
  10003: 'license无效',
  10004: '用户名已存在',
  10005: '用户名或密码错误',
  10006: '用户名不存在',
  10007: 'IP不存在',
  10008: '服务未调通',
  10009: '生成下载文件失败',
  10010: '验证码错误',
  10011: '连续多次密码错误，账号将被锁定十分钟，请稍后再试',

  20001: '证书已存在',
  20002: '证书格式错误',
  20003: '证书私钥不匹配',
  20004: '组织不存在',
  20005: '节点名称已存在',
  20006: '用户名已存在',
  20007: '证书来源不是CA服务',
  20008: '证书已经撤销',
  20009: '组织证书已存在',
  200010: 'CAService已存在',
  200012: 'CAService使用中',

  30001: '连接失败',
  30002: '签名证书错误',
  30003: '通信证书错误',
  30004: '链错误',

  40001: '合约名已存在',
  40002: '合约投票中',
  40003: '合约不能冻结',
  40004: '合约不能解冻',
  40005: '合约不能撤销',
  40006: '投票类型失败',
  40007: '合约不能升级',
  40008: '运行时类型错误',
  40009: '合约版本相同',
  40010: '调用链上合约错误',
  40011: '合约不存在',

  50001: '加入通道中，下一个周期内您才能交易，请稍后',
  50002: '正在进行通道内共识，请稍后进行交易',
  50003: '通道不存在，请先创建通道',
  50004: '该链下节点 ID 已经在该通道中，请勿再次加入',
  50005: '通道已存在，不能再创建，可以加入该通道',
  50006: '未订阅该节点或未加入该通道，请先订阅节点或加入通道',
  50007: '该链不支持 docker vm，不能安装链下扩容合约',
  50008: '链下扩容节点已存在，请勿再次创建',
  50009: '目标节点未在线，无法交易',

  51001: '链下扩容用户已存在',
  51002: '链下扩容用户余额不足',
  51003: '链下扩容交易不存在',
  51004: '链下扩容用户已加入链下通道',
  51005: '链下扩容用户挑战失败',
  51006: '链下扩容不同链之间不能加入通道',
  51007: '链下扩容用户不存在',

  52001: '跨链服务已创建，请勿再次创建',
  52002: '跨链服务包正在创建中',
  52003: '跨链服务未运行',

  53001: 'SPV 已创建，请勿再次创建',
  53002: 'SPV 包正在创建中',
  53003: 'SPV 未运行',
  53004: 'SPV 调用未查询到区块信息',

  60001: '预言机ID已存在',
  60002: '预言机ID不存在',
  60003: '预言机ID正在创建中',
  60004: '预言机访问不通',
  60005: '预言机数据库操作失败',
  60006: '预言机安装合约失败',
  60007: '预言机未订阅',

  70001: '归档错误',
  70002: '归档时间解析错误',
  70003: '归档高度计算错误',
  70004: '恢复归档错误',
  70005: '区块高度查询归档错误',
  70006: '区块Hash查询归档错误',
  70007: '交易ID查询归档错误',
  70008: '交易ID查询交易错误',
  70009: '查询归档高度错误'
}
